import { useState } from 'react';

/** 백업 파일 복원 입력. 현재 데이터가 있으면 복원 전에 스냅샷으로 보관된다. */
export function RestoreBackup({ busy, onRestore }: { busy: boolean; onRestore: (text: string, pass: string) => void }) {
  const [file, setFile] = useState<File | null>(null);
  const [pass, setPass] = useState('');
  const [agree, setAgree] = useState(false);
  return (
    <details>
      <summary>백업 파일에서 복원</summary>
      <div className="stack">
        <input
          type="file"
          accept=".counselai-backup,application/octet-stream"
          onChange={(e) => setFile(e.target.files?.[0] ?? null)}
        />
        <label>
          백업할 때의 passphrase
          <input type="password" value={pass} onChange={(e) => setPass(e.target.value)} autoComplete="off" />
        </label>
        <label className="check">
          <input type="checkbox" checked={agree} onChange={(e) => setAgree(e.target.checked)} /> 이 기기의 현재
          데이터(있다면)는 스냅샷으로 보관된 뒤 백업 내용으로 교체됩니다
        </label>
        <button
          type="button"
          className="danger"
          disabled={busy || !file || !pass || !agree}
          onClick={() => void file?.text().then((t) => onRestore(t, pass))}
        >
          복원
        </button>
      </div>
    </details>
  );
}
